import script from "./section2.vue?vue&type=script&setup=true&lang=js"
export * from "./section2.vue?vue&type=script&setup=true&lang=js"

import "./section2.vue?vue&type=style&index=0&id=47909442&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47909442"]])

export default __exports__